import React from 'react';
import styled from 'styled-components';


// important file imports
import Header from './components/header';
import Sidebar from './components/Sidebar';
import Chat from './components/Chat';


export default function Home() {
  return (
    <>
      <Header/>
      <Appbody>
        <Sidebar/>
        <Chat/>
      </Appbody>
    </>
  )
}

const Appbody=styled.div`
display: flex;
height: 100vh;

`;


